import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
    appTopBar: {
        top: 0,
        bottom: 'auto',
    },
    grow: {
        flexGrow: 1,
    },
    labelOne: {
        fontSize: 40,
        fontWeight: 'bold',
        fontFamily: 'effra',
        color: '#1A237A',
    },
    labelTwo: {
        fontSize: 24,
        fontWeight: 'regular',
        fontFamily: 'effra',
        color: '#69737A',
    },
    align: {
        textAlign: 'center',
    },
}));

const SuccessScreen = () => {

    const classes = useStyles();
    return (
        <Grid container spacing={4}>
            <img src={require('./../assets/Contele-Fleet-Tracking.png')} alt="" className="topLogoImage" />
            <AppBar position="fixed" color="inherit" className={classes.appTopBar}>
                <Toolbar>
                    <div className={classes.grow} />
                </Toolbar>
            </AppBar>
            <Grid item xs={12} sm={12} className={classes.align}>
                <img src={require('./../assets/success-image.png')} alt="" />
            </Grid>
            <Grid item xs={12} sm={12} className={classes.align} style={{ paddingBottom: '8px', }}>
                <label className={classes.labelOne}>Success! Everything set.</label>
            </Grid>
            <Grid item xs={12} sm={12} className={classes.align} style={{ paddingTop: '8px', }}>
                <label className={classes.labelTwo}>Check your email for more information.</label>
            </Grid>
            <Grid item xs={12} sm={12} className={classes.align} style={{ paddingTop: '32px', }}>
                <Button variant="contained" color="primary" className={useStyles.button} style={{ width: '274px', height: '48px', }} onClick={() => window.location.href = 'https://contelerastreador.com.br/app/usuarios/login'}>
                    Continue
                </Button>
            </Grid>
        </Grid>
    );
};

export default SuccessScreen;